import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AppLoaderService } from '../services/app-loader.service';
import { LoaderState } from '../Utils/LoaderState';

@Component({
    selector: 'app-loader',
    templateUrl: '../templates/template1/views/app-loader.component.html',
    styleUrls: ['../templates/template1/themes/default/CSS/app-loader.component.less']
  })
  export class AppLoaderComponent implements OnInit {
  
    show = false;
  
  private subscription: Subscription;
  
  constructor(
          private loaderService: AppLoaderService          
      ) { }
  
  ngOnInit() { 
          this.subscription = this.loaderService.loaderState
              .subscribe((state: LoaderState) => {              
                  this.show = state.show;
              });    
      }
  
  ngOnDestroy() {
          this.subscription.unsubscribe();
      }
  }
  


// WEBPACK FOOTER //
// ./src/app/shared/components/app-loader.component.ts